import { type App } from 'vue';
import { RouteLocationNormalized, createRouter, createWebHistory } from 'vue-router';

import { i18n, targetLocale, loadMessages } from '@/i18n';

import { getToken } from '@/utils/storage';
import { handleUnauthorizedRequest } from '@/utils/fetch';

import { routes } from './routes';

function authGuard(to: RouteLocationNormalized) {
  const hasToken = Boolean(getToken());
  if (!hasToken) {
    console.error('No token detected.');
    handleUnauthorizedRequest(to.fullPath);

    return false;
  }

  return true;
}

const router = createRouter({
  history: createWebHistory(targetLocale),
  routes,
});

/**
 * Navigation guard for loading the translations asynchronously
 */
router.beforeEach(async (_to, _from, next) => loadMessages(i18n).then(() => next()));
router.beforeResolve((to: RouteLocationNormalized) => authGuard(to));

export const initializeRouter = (app: App) => app.use(router);

export default router;
